import { Component, OnInit, Input } from '@angular/core';
import {
  MemberCard,
  MemberCardQuery,
  MemberDetails,
  Balance,
  BalanceQuery,
  config,
  CardTokenQuery,
  CardToken,
} from '@fgb/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgb-member-card',
  templateUrl: './member-card.component.html',
  styleUrls: ['./member-card.component.scss'],
})
export class MemberCardComponent implements OnInit {
  @Input() showSeating: boolean;
  @Input() isAccount: boolean;
  memberCard$: Observable<MemberCard | undefined>;
  ecash$: Observable<number | undefined>;
  
  balance$: Observable<Balance>;
  member$: Observable<MemberDetails | undefined>;
  cardToken$: Observable<CardToken | undefined>;

  constructor(
    private memberCardQuery: MemberCardQuery,
    private balanceQuery: BalanceQuery,
    private cardTokenQuery: CardTokenQuery
  ) {}

  ngOnInit() {
    this.memberCard$ = this.memberCardQuery.selectCurrentCard();
    this.ecash$ = this.balanceQuery.selectPurse(config.purseConfig.combined);
    this.cardToken$ = this.cardTokenQuery.selectDefaultCard();
  }
}
